import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    // User is not authenticated
    return <Navigate to="/login" replace />;
  }

  // Check if specific role is required
  if (requiredRole && user.role !== requiredRole && user.role !== 'super_admin') {
    // User doesn't have the required role
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;